import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { RefreshCw } from 'lucide-react';

const GOLD = '#FFD700';

export default function AdminAutoAdLog() {
  const [ads, setAds] = useState([]);
  const [sortDesc, setSortDesc] = useState(true);

  const load = async () => {
    try {
      const res = await axios.get(`${API}/medulla/auto-ads`);
      setAds(res.data || []);
    } catch { /* silent */ }
  };

  useEffect(() => { load(); }, []);

  const sorted = [...ads].sort((a, b) =>
    sortDesc
      ? new Date(b.created_at) - new Date(a.created_at)
      : new Date(a.created_at) - new Date(b.created_at)
  );

  return (
    <Card className="p-5 mt-4"
      style={{
        background: 'rgba(15, 15, 5, 0.9)',
        border: `1px solid ${GOLD}55`,
        boxShadow: `0 0 15px ${GOLD}22`
      }}
    >
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-bold" style={{ color: GOLD, textShadow: `0 0 8px ${GOLD}` }}>
          📣 Auto Ad Log
        </h3>
        <Button
          data-testid="refresh-auto-ads"
          onClick={load}
          size="sm"
          variant="outline"
          className="border-slate-700"
        >
          <RefreshCw className="w-3 h-3 mr-1" /> Refresh
        </Button>
      </div>

      {ads.length === 0 ? (
        <p className="text-sm text-slate-500 text-center py-4">
          No auto-ads generated yet. They fire when a venue&apos;s vibe score hits 75+ or check-ins drop below threshold.
        </p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="text-left border-b border-slate-700">
                <th className="py-2 pr-2" style={{ color: GOLD }}>Venue</th>
                <th
                  className="py-2 pr-2 cursor-pointer"
                  style={{ color: GOLD }}
                  onClick={() => setSortDesc(s => !s)}
                >
                  Timestamp {sortDesc ? '↓' : '↑'}
                </th>
                <th className="py-2 pr-2" style={{ color: GOLD }}>Post Content</th>
                <th className="py-2 pr-2" style={{ color: GOLD }}>Score / Triggers</th>
                <th className="py-2 pr-2" style={{ color: GOLD }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {sorted.map(a => (
                <tr key={a.id} data-testid={`auto-ad-${a.id}`} className="border-b border-slate-800">
                  <td className="py-2 pr-2 text-white font-bold">{a.venue_name}</td>
                  <td className="py-2 pr-2 text-slate-400">
                    {new Date(a.created_at).toLocaleString()}
                  </td>
                  <td className="py-2 pr-2 text-slate-200 max-w-xs">
                    <span className="line-clamp-2">{a.post_content}</span>
                  </td>
                  <td className="py-2 pr-2">
                    <div className="text-white">{a.trigger_score}</div>
                    <div className="text-[10px] text-slate-500">
                      {a.trigger_type || 'high_vibe'}
                      {a.push_sent_count != null && ` · ${a.push_sent_count} push`}
                    </div>
                    <div className="text-[10px] text-slate-500">
                      {(a.platforms || ['instagram']).join(' · ')}
                    </div>
                  </td>
                  <td className="py-2 pr-2">
                    <span className={
                      a.status === 'posted' ? 'text-green-400'
                      : a.status === 'pending_post' ? 'text-yellow-400'
                      : 'text-slate-400'
                    }>
                      {a.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
